export const ADD_CLIENT_LEAVE_DESCRIPTION =
  'Are you sure you want to cancel “Add Client”? All the changes will be discarded.';

export const EDIT_CLIENT_LEAVE_DESCRIPTION =
  'Are you sure you want to cancel “Edit Client Profile”? All the changes will be discarded.';

export const FORM_LOAD_ERROR = 'Failed to load the form. Please try again.';
